import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Link, BrowserRouter, Route, Routes } from "react-router-dom";
import { PostHogProvider } from "posthog-js/react";

import "assets/scss/material-kit-pro-react.scss?v=1.3.0";

// pages for this product
import AboutUsPage from "./views/AboutUsPage/AboutUsPage";
import BlogPostPage from "./views/BlogPostPage/BlogPostPage";
import BlogPostsPage from "./views/BlogPostsPage/BlogPostsPage";
import ComponentsPage from "./views/ComponentsPage/ComponentsPage";
import ContactUsPage from "./views/ContactUsPage/ContactUsPage";
import EcommercePage from "./views/EcommercePage/EcommercePage";
import LandingPage from "./views/LandingPage/LandingPage";
import LoginPage from "./views/LoginPage/LoginPage";

//import PaginaPrincipal from './views/PresentationPage/Principal'

import PaginaPrincipal from "./Componentes/PaginaPrincipal/Principal.jsx";
import Diseñador3D from "./Componentes/Diseñador3D/Diseñador.jsx";

import PricingPage from "./views/PricingPage/PricingPage";
import ProfilePage from "./views/ProfilePage/ProfilePage";
//import ProductPage from './views/ProductPage/ProductPage';
import SectionsPage from "./views/SectionsPage/SectionsPage";
import Carrito from "./Componentes/Carrito/Carrito.jsx";
// import Login from "./Componentes/Login/Login.jsx";
import Login from "./Componentes/Login/LoginAuth0.jsx";
import ErrorPage from "./views/ErrorPage/ErrorPage";
import CartPage from "views/PlayerasPage/CartPage.jsx";
import Playeras from "views/PlayerasPage/ProductDetailPage.jsx";
import ListaDeseos from "./Componentes/ListaDeseos/ListaDeseos.jsx";
import ConfirmarCompra from "./Componentes/ConfirmarCompra/ConfirmarCompra.jsx";
import SeleccionProducto from "./Componentes/SeleccionProducto/SeleccionDeDiseño.jsx";
import Perfil from "./Componentes/PerfilUsuario/Perfil.jsx";
import Verificar from "./Componentes/PerfilUsuario/VerificacionIdentidad.jsx";
import Artistas from "./Componentes/Artistas/Artistas";

import GaleriaProductos from "./views/Galeria/GaleriaProductos";
import AvisoPrivacidad from "./Componentes/PaginaPrincipal/AvisoPrivacidad.jsx";
import TerminosCondiciones from "./Componentes/PaginaPrincipal/TerminosCondiciones.jsx";
import { Auth0Provider, useAuth0 } from "@auth0/auth0-react";
import { setAccessTokenProvider, setAuth0AuthenticatedChecker, setSessionExpiredHandler } from "./api/configs/axiosConfigs";
import Layout from "./components/Layout/Layout.jsx";
import "assets/fonts/Fuentes.css";
import "assets/scss/Stylist.css";
import "assets/scss/AnimationCheck.css";
import ScrollToTop from "./components/Layout/ScrollToTop.jsx";

var hist = createBrowserHistory();

const options = {
	api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
	autocapture: true,
	capture_pageview: true,
	capture_pageleave: true,
	session_recording: { maskAllInputs: true },
	// defaults: '2025-05-24',
};

// wrapper para inyectar el access token

function Auth0TokenConnector({ children }) {
	const { getAccessTokenSilently, isAuthenticated, isLoading, logout } = useAuth0();
	const auth0ReadyRef = useRef({ ready: false, resolve: null, promise: null });

	if (!auth0ReadyRef.current.promise) {
		auth0ReadyRef.current.promise = new Promise((resolve) => {
			auth0ReadyRef.current.resolve = resolve;
		});
	}

	useEffect(() => {
		// Cuando Auth0 termina de cargar, resolvemos la promesa
		if (!isLoading && !auth0ReadyRef.current.ready) {
			auth0ReadyRef.current.ready = true;
			auth0ReadyRef.current.resolve(); // 🔥 libera los awaits en curso
		}
	}, [isLoading]);

	const esperarAuth0 = async () => {
		if (!auth0ReadyRef.current.ready) {
			await auth0ReadyRef.current.promise;
		}
	};

	useEffect(() => {
		// REGISTRA proveedor de tokens para tu axios wrapper
		setAccessTokenProvider({
			// Obtener token (usa caché si existe; si expiró, el SDK lo renueva con RTR)
			get: async () => {
				await esperarAuth0();
				if (!isAuthenticated) return null;
				return await getAccessTokenSilently({
					authorizationParams: {
						audience: import.meta.env.VITE_AUTH0_AUDIENCE,
						scope: "openid profile email offline_access", // 👈 ADD
					},
					// cache default (on) está bien aquí
				});
			},

			// Forzar renovación (usa solo ante 401 o cuando tú quieras refrescar manual)
			refresh: async () => {
				if (!isAuthenticated) return null;
				try {
					return await getAccessTokenSilently({
						authorizationParams: {
							audience: import.meta.env.VITE_AUTH0_AUDIENCE,
							scope: "openid profile email offline_access",
						},
						cacheMode: "off", // 👈 fuerza renovar evitando caché
					});
				} catch (e) {
					// retry ligero para errores transitorios de red
					await new Promise((r) => setTimeout(r, 300));
					return await getAccessTokenSilently({
						authorizationParams: {
							audience: import.meta.env.VITE_AUTH0_AUDIENCE,
							scope: "openid profile email offline_access",
						},
						cacheMode: "off",
					});
				}
			},
		});
		
		// Configurar callback para verificar autenticación desde el interceptor
		setAuth0AuthenticatedChecker(() => isAuthenticated);
		
		// Configurar callback para manejar sesión expirada
		setSessionExpiredHandler(() => {
			// Verificar que todavía está autenticado antes de hacer logout
			// Esto evita hacer logout durante el flujo de login
			if (!isAuthenticated) {
				return;
			}
			
			// Emitir evento para mostrar notificación
			const event = new CustomEvent('sessionExpired', {
				detail: { message: 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.' }
			});
			window.dispatchEvent(event);
			
			// Hacer logout después de un breve delay para que se muestre la notificación
			// Redirigir a la página principal después del logout
			setTimeout(() => {
				logout({ logoutParams: { returnTo: window.location.origin + "/" } });
			}, 100);
		});
	}, [isAuthenticated, getAccessTokenSilently, logout]);

	return children;
}

// Verificar que el elemento root existe
const rootElement = document.getElementById("fb-root");
if (!rootElement) {
	console.error("❌ No se encontró el elemento #fb-root en el DOM");
	throw new Error("Elemento root #fb-root no encontrado");
}

// Validar que las variables de entorno estén definidas
const auth0Domain = import.meta.env.VITE_AUTH0_DOMAIN;
const auth0ClientId = import.meta.env.VITE_AUTH0_CLIENTID;
const auth0Audience = import.meta.env.VITE_AUTH0_AUDIENCE;

// Debug: mostrar variables de entorno en desarrollo
if (import.meta.env.DEV) {
	console.log("🔍 Variables de entorno:", {
		domain: auth0Domain,
		clientId: auth0ClientId
			? `${auth0ClientId.substring(0, 10)}...`
			: "undefined",
		audience: auth0Audience,
		apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
	});
}

if (!auth0Domain || !auth0ClientId || !auth0Audience) {
	console.error("❌ Variables de entorno de Auth0 no están definidas:", {
		domain: auth0Domain,
		clientId: auth0ClientId,
		audience: auth0Audience,
	});
	// Crear un mensaje visual en la página si faltan variables críticas
	rootElement.innerHTML =
		'<div style="padding: 20px; color: red; font-family: monospace;"><h1>⚠️ Error de Configuración</h1><p>Variables de entorno de Auth0 no están definidas. Revisa la consola para más detalles.</p><p>Reinicia el servidor después de actualizar el archivo .env</p></div>';
}

ReactDOM.render(
	<Auth0Provider
		// domain="dev-gvfh37srdd16jo6s.us.auth0.com"
		// clientId="8aYs9mmhJSjW0AsISxGRdlNmH5Xum160"
		domain={auth0Domain}
		clientId={auth0ClientId}
		authorizationParams={{
			redirect_uri: window.location.origin + "/login",
			audience: auth0Audience,
			scope: "openid profile email",
		}}
		useRefreshTokens={true}
		cacheLocation="localstorage"
	>
		<Auth0TokenConnector>
			{/* <PostHogProvider apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY} options={options}> */}
			<BrowserRouter>
				<Layout>
					<ScrollToTop />
					<Routes>
						{/* Verificacion de identidad */}
						<Route path="/ValidarAcceso" element={<Verificar />} />

						<Route path="/playeras" element={<Playeras />} />
						<Route path="/carrito-compras" element={<CartPage />} />
						<Route path="/galeria-productos" element={<GaleriaProductos />} />
						<Route path="/about-us" element={<AboutUsPage />} />
						<Route path="/blog-post" element={<BlogPostPage />} />
						<Route path="/blog-posts" element={<BlogPostsPage />} />
						<Route path="/components" element={<ComponentsPage />} />
						<Route path="/contact-us" element={<ContactUsPage />} />
						<Route path="/ecommerce-page" element={<EcommercePage />} />
						<Route path="/landing-page" element={<LandingPage />} />
						<Route path="/login-page" element={<LoginPage />} />
						<Route path="/pricing" element={<PricingPage />} />
						<Route path="/profile-page" element={<ProfilePage />} />
						<Route path="/sections" element={<SectionsPage />} />
						{/* <Route path="/shopping-cart-page" component={ShoppingCartPage} /> */}

						<Route path="/error-page" element={<ErrorPage />} />

						{/**Nuevas rutas */}
						<Route path="/Artistas" element={<Artistas />} />

						<Route path="/Perfil" element={<Perfil />} />
						<Route path="/Tienda/:id" element={<Perfil />} />
						<Route path="/SeleccionaTuDiseño" element={<SeleccionProducto />} />
						<Route path="/lista-deseos" element={<ListaDeseos />} />
						<Route path="/confirmar-compra" element={<ConfirmarCompra />} />
						<Route path="/login" element={<Login />} />
						<Route path="/carrito" element={<Carrito />} />
						<Route path="/diseñador3D" element={<Diseñador3D />} />
						<Route path="/avisoPrivacidad" element={<AvisoPrivacidad />} />
						<Route
							path="/terminosCondiciones"
							element={<TerminosCondiciones />}
						/>
						<Route path="/" element={<PaginaPrincipal />} />
					</Routes>
				</Layout>
			</BrowserRouter>
		</Auth0TokenConnector>
	</Auth0Provider>,
	rootElement
);
